var map;
var cachedGeoJson;

import './_bootstrap';

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.disableSearchExposedAjax = {
    attach: function (context) {
      if (Drupal.views !== undefined && Drupal.view.ajaxView !== undefined) {
        Drupal.views.ajaxView.prototype.attachExposedFormAjax = function () {
          const that = this;
          this.exposedFormAjax = [];
          // Exclude the reset buttons so no AJAX behaviors are bound. Many things
          // break during the form reset phase if using AJAX.
          $("input[type=submit], button[type=submit], input[type=image]", this.$exposed_form).not("[data-drupal-selector=edit-reset]").not("[disable-exposed-ajax-submit]").each(function (index) {
            const selfSettings = $.extend({}, that.element_settings, {
              base: $(this).attr("id"),
              element: this
            });
            that.exposedFormAjax[index] = Drupal.ajax(selfSettings);
          });
        };
      }
    }
  };

  Drupal.behaviors.locationsGoogleMapInit = {
    attach: function (context) {
      $(once('locationsGoogleMap', 'body .view-regions-map'), context).each(function() {
        $(document).on('geofieldMapInit', function (e, mapid) {
          if (mapid.indexOf('geofield-map-view-regions-map-block-1') == -1) {
            return;
          }

          map = Drupal.geoFieldMapFormatter.map_data[mapid].map;
          // Load GeoJSON.
          var promise = jQuery.getJSON("/themes/custom/nsh/nsha-regions.geojson"); //same as map.data.loadGeoJson();

          promise.then(function(data) {
            cachedGeoJson = data; //save the geojson in case we want to update its values

            map.data.addGeoJson(cachedGeoJson,{idPropertyName:"id"});

            var bounds = new google.maps.LatLngBounds();

            map.data.forEach(function(feature){
              feature.getGeometry().forEachLatLng(function(latlng){
                bounds.extend(latlng);
              });
            });

            map.fitBounds(bounds, 0);

            map.data.setStyle(function(feature) {
              var region = feature.getProperty('name');
              var color = "gray";

              switch (region) {
                case 'Northern':
                  color = '#4db847';
                  break;
                case 'Eastern':
                  color = '#1d6184';
                  break;
                case 'Central':
                  color = '#9fbc43';
                  break;
                case 'Western':
                  color = '#16aaa7';
                  break;
              }

              return {
                fillColor: color,
                strokeColor: '#ffffff',
                fillOpacity: 0.75,
                strokeWeight: 1
              }
            });
          });

          map.data.addListener('mouseover', function(event) {
            map.data.revertStyle();
            map.data.overrideStyle(event.feature, {fillOpacity: 1});
          });

          map.data.addListener('mouseout', function(event) {
            map.data.revertStyle();
          });

          map.data.addListener('click', function(event) {
            var region = event.feature.getProperty('name');
            window.location = '/nova-scotia-canada/' + region.toLowerCase() + '-nova-scotia';
          });

          jQuery(window).resize(function() {
            var bounds = new google.maps.LatLngBounds();
            map.data.forEach(function(feature){
              feature.getGeometry().forEachLatLng(function(latlng){
                bounds.extend(latlng);
              });
            });

            map.fitBounds(bounds, 0);
          });

        });
      })
    }
  };

  Drupal.behaviors.eventsCalendar = {
    attach: function (context) {
      $(once('run-once', 'a.count'), context).on('click', function (e) {
        var date = $(this).data('date');

        $('.calendar-events .calendar-event').hide();
        $('.calendar-main .calendar-day').not('.date-' + date).removeClass('active');

        if ($('.events-floater').length) {
          $('.events-floater').remove();
        }

        if ($(this).parent().parent().hasClass('active')) {
          $(this).parent().parent().removeClass('active');
        }
        else {
          var parent_row = $(this).closest('.calendar-week');
          var day_events = '';

          $('.calendar-events .calendar-wrap.date-' + date).each(function (e) {
            day_events += $(this).html();
          });

          $('<div class="events-floater"><div class="inside">' + day_events + '</div></div>').insertAfter(parent_row);
          $(this).parent().parent().addClass('active');
        }

        return false;
      });
    }
  };

  Drupal.behaviors.contactForm = {
    attach: function (context) {
      if ($('.webform-submission-contact-form', context).length) {
        $(once('run-once', '.webform-submission-contact-form select#edit-subject'), context).on('change', function(e) {
          var subject = $(this).val();

          // Hide all
          $('.view-contact-subject .views-row').hide();

          // Show if index > 0
          if (subject) {
            $('.views-row.subject-' + subject).show();

            if (!$('.views-row.subject-' + subject + ' article.internal').length) {
              $('.webform-submission-contact-form .form-group').not('.form-item-subject').hide();
              $('.webform-submission-contact-form .captcha').hide();
              $('.webform-submission-contact-form .form-actions').hide();
            }
            else {
              $('.webform-submission-contact-form .form-group').not('.form-item-subject').show();
              $('.webform-submission-contact-form .captcha').show();
              $('.webform-submission-contact-form .form-actions').show();
            }
          }
          else {
            $('.webform-submission-contact-form .form-group').not('.form-item-subject').hide();
            $('.webform-submission-contact-form .captcha').hide();
            $('.webform-submission-contact-form .form-actions').hide();
          }
        });
      }
    }
  };

  Drupal.behaviors.opportunityReadMore = {
    attach: function (context) {
      $(once('run-once', '.node-type--opportunity .opportunity-read-more a'), context).on('click', function (e) {
        $('.node-type--opportunity .apply-here').removeClass('apply-here');
        $(this).delete();
        return false;
      });
    }
  };

  Drupal.behaviors.opportunityAlerts = {
    attach: function (context) {
      $(once('run-once', '.opportunity-alerts > .alerts > .opportunity-alert > .right > a.notify'), context).on('click', function (e) {
        var oid = $(this).data('oid');
        var type = $(this).data('notify');
        $(this).toggleClass('selected');

        if ($(this).hasClass('selected')) {
          $('form.alerts-form input[name="' + type + '_' + oid + '"]').val(1);
        }
        else {
          $('form.alerts-form input[name="' + type + '_' + oid + '"]').val(0);
        }

        return false;
      });

      $(once('run-once', '.opportunity-alerts > .alerts > .opportunity-alert > .right > a.remove'), context).on('click', function (e) {
        var oid = $(this).data('oid');

        $(this).parent().parent().addClass('delete');
        $('form.alerts-form input[name="delete_' + oid + '"]').val(1);

        console.log($('form.alerts-form input[name="delete_' + oid + '"]').val());
        return false;
      });

      $(once('run-once', 'form.alerts-form'), context).on('submit', function (e) {
        var del = $('.opportunity-alert.delete').length;
        if (del) {
          return confirm('You are about to delete ' + del + ' alert' + (del != 1 ? 's' : '') + '. Are you sure?');
        }
      });

    }
  };

  Drupal.behaviors.datepickerChange = {
    attach: function (context) {
      $(once('run-once', '.bef-datepicker'), context).each(function() {
        $('.bef-datepicker').datepicker({dateFormat: 'M d, yy'});
        var current = moment();
        var oneMonth = moment(current).add(1, 'M');

        $('#edit-date-min').val(current.format('MMM D, YYYY'));
        $('#edit-date-max').val(oneMonth.format('MMM D, YYYY'));
      });
    }
  }

  Drupal.behaviors.opportunityCountdown = {
    attach: function (context) {
      $(once('run-once', 'body.node-opportunity .countdown'), context).each(function() {
        const exp = moment($('.countdown').data('date'));

        var timer = setInterval(function() {
          let now = moment().format();
          let diffDuration = moment.duration(exp.diff(now));

          if (diffDuration >= 0) {
            var days = exp.diff(now, 'days');
            $('.countdown > .days > strong').text(days);
            $('.countdown > .hours > strong').text(diffDuration.hours());
            $('.countdown > .minutes > strong').text(diffDuration.minutes());
            $('.countdown > .seconds > strong').text(diffDuration.seconds());
            $('.countdown').removeClass('invisible');
          }
          else {
            clearInterval(timer);
            $('.countdown').addClass('invisible');
          }
        }, 1000);
      });
    }
  }

  Drupal.behaviors.sectionWidget = {
    attach: function (context) {
      $(once('run-once', 'body.node-type--place'), context).each(function() {
        $(window).scroll(function(){
          // calculate how far we've scrolled down, by percentage
          var currentTop = $(window).scrollTop();
          $('.section-link').removeClass('active');

          var show = $('article.place--module').offset().top;

          if (currentTop >= show) {
            $('#sections-widget').fadeIn();
          }
          else {
            $('#sections-widget').fadeOut();
          }

          var hit = -1;
          var elem;

          // Get position of sections
          for (var x = $('.views-field-field-section > .field-content > .paragraph').length; x > 0 ; x--) {
            //console.log(currentTop + '>=' + $('.section', context).eq(x).offset().top);
            elem = $('.views-field-field-section > .field-content > .paragraph').eq(x-1);

            if (currentTop + 5>= elem.offset().top) {
              hit = x;
              $('.section-link').eq(hit).addClass('active');
              break;
            }
          }

          if (hit == -1) {
            $('.section-link').eq(0).addClass('active');
          }

        }).trigger('scroll');
      });
    }
  }


})(jQuery, Drupal);
